import { Button, Flex, Spacer, Text } from '@cellula/react';
import { withTranslation } from '../../with_translation';
import { tokens } from '@cellula/react-theme-patient';
import { useNavigate } from 'react-router-dom';
import { SessionController } from '../../session.controller';
import { useResolve } from '@visiba/instantiation';

interface Props {}

export function NotFound(_: Props): JSX.Element {
	const navigate = useNavigate();
	const controller = useResolve(SessionController);

	function handleBackButtonClick() {
		navigate(`/${controller.languageCode}-${controller.countryCode}`);
	}

	return (
		<div style={{ textAlign: 'center' }}>
			<Spacer vertical={tokens.spacing.x8} />
			<Text.h1 variant='headingMedium'>{withTranslation('error-404.title')}</Text.h1>
			<Spacer vertical={tokens.spacing.x4} />
			<Text.p variant='bodyRegular'>{withTranslation('error-404.description')}</Text.p>
			<Spacer vertical={tokens.spacing.x4} />
			<Flex direction='row' justify='center'>
				<Button onClick={handleBackButtonClick}>{withTranslation('error-404.button-back')}</Button>
			</Flex>
		</div>
	);
}
